import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCloudDownloadAlt as fasCloudDownloadAlt,
  faHeart as fasHeart,
  faHome as fasHome,
  faPause as fasPause,
  faPlay as fasPlay,
  faStop as fasStop,
  faTimes as fasTimes,
} from '@fortawesome/free-solid-svg-icons'
import {
  faAngleRight,
  faCalendarAlt,
  faChevronLeft,
  faClock,
  faCloudDownloadAlt,
  faCog,
  faCommentDots,
  faFileInvoiceDollar,
  faDollarSign,
  faEuroSign,
  faHryvnia,
  faInfoCircle,
  faLiraSign,
  faLongArrowRight,
  faMinus,
  faPencil,
  faPlus,
  faPoundSign,
  faRubleSign,
  faRupeeSign,
  faShekelSign,
  faSignIn,
  faSignOut,
  faSort,
  faStopwatch,
  faTenge,
  faTrash,
  faWonSign,
  faYenSign,
} from '@fortawesome/pro-regular-svg-icons'
import {
  faClub as fasClub,
  faDiamond as fasDiamond,
  faSpade as fasSpade,
} from '@fortawesome/pro-solid-svg-icons'

library.add(
  faAngleRight,
  faCalendarAlt,
  faChevronLeft,
  faClock,
  faCloudDownloadAlt,
  faCog,
  faCommentDots,
  faDollarSign,
  faEuroSign,
  faFileInvoiceDollar,
  faHryvnia,
  faInfoCircle,
  faLiraSign,
  faLongArrowRight,
  faMinus,
  faPencil,
  faPlus,
  faPoundSign,
  faRubleSign,
  faRupeeSign,
  fasCloudDownloadAlt,
  fasClub,
  fasDiamond,
  fasHeart,
  faShekelSign,
  fasHome,
  faSignIn,
  faSignOut,
  faSort,
  fasPause,
  fasPlay,
  fasSpade,
  fasStop,
  fasTimes,
  faStopwatch,
  faTenge,
  faTrash,
  faWonSign,
  faYenSign,
)
